import { Pressed } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ActionStyled = styled(Pressed)(() => ({
  borderRadius: 4,
  width: 32,
  height: 32,
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${Colors.gray300}`,
}));
